<template v-if="package">
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <div style="height:300px;width:50%;float:left;display:flex;">
        <div style="align-self:center">
          <h1 style="text-decoration: underline;">
            Membership Summary:
          </h1>
          <ul>
            <h3>{{ dataPackage.name }}</h3>
            <li><span style="font-size:16px">{{ dataPackage.description }}</span></li>
            <li><span style="font-size:16px">Full Access to Premium Picks</span></li>
            <li><span style="font-size:16px">Pick Notifications to Text/Email</span></li>
            <li><span style="font-size:16px">Access Unit Based Bankroll Strategy</span></li>
            <li><span style="font-size:16px"><b>Price:</b> ${{ dataPackage.current_price }}</span></li>
          </ul>
        </div>
      </div>
      <!-- main-colum START here -->
      <div style="height:auto;width:50%;float:right">
        <div id="paypal-button-container" class="paypal-button-container"></div>
        <div class="Spacer-module_divider__ewqEj">
          <span>OR</span>
        </div>
        <!-- Containers for card fields hosted by PayPal -->
        <div id="card-form" class="card_container">
          <span style="color: red">{{ errorMessage }}</span>
          <div id="card-name-field-container"></div>
          <div id="card-number-field-container"></div>
          <div id="card-expiry-field-container"></div>
          <div id="card-cvv-field-container"></div>
          <button id="card-field-submit-button" type="button" :disabled="purchaseDisabled" @click="debouncedClick()">
            {{ buttonText }}
          </button>
        </div>

        <div style="padding-top:20px;">
          <small>
            <p>
              <b>Payment:</b> Payment is processed securely through PayPal/Braintree.
              Payment information is not accessible or stored by us in any form. We never have access to your payment details.
            </p>
          </small>
          <small>
            <p>
              <b>One Time Payment:</b> Memberships are one time payments. We will never charge your account.
              When your membership expires, you will need to purchase a new membership to continue receiving premium content. This is not a subscription.
            </p>
          </small>
          <small>
            <p>
              <b>Disclaimer:</b> All sales are final. Previous results do not indicate future performance. No refunds will be issued.
              By purchasing a membership, you agree to the terms and conditions
              outlined in the
              <router-link :to="{ path: '/terms' }">terms of service</router-link> and <router-link :to="{ path: '/disclaimer' }"> disclaimer</router-link>.
            </p>
          </small>
        </div>
      </div>

      <!-- main-colum END here -->
    </div>
    <!-- container end here -->
  </div>
</template>

<script>
import PurchaseRepository from '../data/purchase.repository'
import _ from 'lodash'

export default {
  components: {},
  // props: ['package'],
  data() {
    return {
      cardField: {},
      purchaseDisabled: false,
      errorMessage: ''
    };
  },
  computed: {
    currentUser () {
      return this.$store.state.currentUser
    },
    dataPackage() {
      return this.getPackage()
    },
    buttonText () {
      return this.currentUser ? `Purchase $${this.dataPackage.current_price}` : `Log in to Purchase`
    },
  },
  created() {
    this.debouncedClick = _.debounce(this.purchase, 1000);
  },
  mounted() {
    var that = this;

    function _routeToSuccess() {
      that.$router.push("/paymentsuccess");
    }
    function _setErrorMessage (message) {
      that.errorMessage = message
    }
    this.$nextTick(() => {
      paypal
        .Buttons({
          // Sets up the transaction when a payment button is clicked
          createOrder: _createOrder,
          onApprove: _onApprove,
          onError: function (error) {
            console.error(error);
            this.errorMessage = error.message || "There was an issue processing your payment";
          },
          funding: {
            disallowed: [paypal.FUNDING.CREDIT],
          },

          style: {
            shape: "rect",
            layout: "vertical",
            color: "gold",
            label: "paypal",
          },
          message: {
            amount: 100,
          },
        })
        .render("#paypal-button-container");
      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            "font-size": "16px",
            "font-family": "courier, monospace",
            "font-weight": "lighter",
            color: "#333333",
          },
          ".invalid": { color: "red" },
        },
      });
      console.log(`IsEligible ${that.cardField.isEligible()}`);
      if (that.cardField.isEligible()) {
        const nameField = that.cardField.NameField();
        nameField.render("#card-name-field-container");
        console.log("render namefield");
        const numberField = that.cardField.NumberField();
        numberField.render("#card-number-field-container");
        const cvvField = that.cardField.CVVField({});
        cvvField.render("#card-cvv-field-container");
        const expiryField = that.cardField.ExpiryField({});
        expiryField.render("#card-expiry-field-container");
      } else {
        this.errorMessage = "Card fields are not available at this time. Please reach out to support@stumpthespread.com";
      }
    });

    async function _onApprove(data, actions) {
      console.log(`onApproveCallback ${JSON.stringify(data)}`)
      const that = this
      try {
        const response = await PurchaseRepository.capture(data)
        console.log(response)

        const orderData = response.data;
        // A 200 means the API accepted the capture and has already granted the
        // membership. That includes the already-captured recovery path, whose
        // body is a PayPal error envelope with no purchase_units, so read
        // defensively and only fail on an explicitly DECLINED transaction.
        const purchaseUnit = (orderData.purchase_units && orderData.purchase_units[0]) || null;
        const payments = purchaseUnit ? purchaseUnit.payments : null;
        const transaction = payments
          ? (payments.captures && payments.captures[0]) || (payments.authorizations && payments.authorizations[0])
          : null;

        if (transaction && transaction.status === "DECLINED") {
          return _setErrorMessage('Your card was declined. Please try a different payment method.');
        }
        return _routeToSuccess();
      } catch (e) {
        console.log('error on approve')
        // Surface the API's message - it distinguishes a declined card from an
        // unapproved order from a genuine failure. e.message is only ever
        // "Request failed with status code NNN", which tells the buyer nothing.
        const serverData = e.response && e.response.data;
        _setErrorMessage(
          (serverData && (serverData.error || serverData.msg)) ||
          'There was an issue processing your payment'
        );
      }
    }

    async function _createOrder(data) {
      try {
        if (!that.currentUser){
          that.$root.$refs.toastr.w('Please log in or register to become a Premium Member')
          return that.$router.push('/register')
        }
        const orderData = await PurchaseRepository.create({
            cart: [
              {
                id: that.dataPackage.id,
                quantity: 1,
                price: that.dataPackage.current_price,
              },
            ],
        })

        if (orderData.data.id) {
          return orderData.data.id;
        } else {
          const errorDetail = orderData.data.details[0];
          const errorMessage = errorDetail
            ? `${errorDetail.issue} ${errorDetail.description} (${orderData.data.debug_id})`
            : JSON.stringify(orderData);

          _setErrorMessage(errorMessage);
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.log("error on purchase")
        that.errorMessage = "There was an issue processing your payment";
        console.error(error);
      }
    }
  },
  methods: {
    getPackage() {
      if (!_.isEmpty(this.$store.state.currentPackage)) {
        return this.$store.state.currentPackage;
      } else if (this.$route.query.package) {
        const pack = this.$store.getters.package(this.$route.query.package);
        return pack ? pack : {id: "ALLMO", current_price: "129", name: "1 Month All Sports Package"};
      } else {
        return {id: "ALLMO", current_price: "129", name: "1 Month All Sports Package"};
      }
    },
    purchase() {
      if (this.purchaseDisabled) return
      if (!this.currentUser || !this.currentUser.id) {
          this.$root.$refs.toastr.w('Please log in or register to become a Premium Member')
          return this.$router.push('/register')
      }
      this.$nextTick(() => {
        this.purchaseDisabled = true
      })
      this.cardField.submit({}).then((data) => {
        console.log(data);
      }).catch((error) => {
        if (error.message === "INVALID_NUMBER") {
          this.errorMessage = "Payment issue: Invalid card number";
        } else if (error.message === "INVALID_EXPIRY") {
          this.errorMessage = "Payment issue: Invalid expiration date";
        } else if (error.message === "INVALID_CVV") {
          this.errorMessage = "Payment issue: Invalid CVV";
        } else {
          this.errorMessage = "There was an issue processing your payment";
        }
        console.error(error);
      }).finally(() => {
        this.purchaseDisabled = false
      });
    },
  },
};
</script>
<style lang="css" scoped>
#card-field-submit-button:disabled {
  opacity: 0.5;
}
/*
https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css
*/
.paypal-button-container {
    border-radius: 5px;
    background-color: #E7E7E7;
    padding: 20px;
    max-width: 760px;
    width: 100%;
    margin: 0 auto;
}
.card_container {
    border-radius: 5px;
    background-color: #E7E7E7;
    padding: 20px;
    max-width: 760px;
    width: 100%;
    margin: 0 auto;
}
.card_field{
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
    height:40px;
    background:white;
    font-size:17px;
    color:#3a3a3a;
    font-family:helvetica, tahoma, calibri, sans-serif;
}
.card_field_50{
    width: 50%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
    height:40px;
    background:white;
    font-size:17px;
    color:#3a3a3a;
    font-family:helvetica, tahoma, calibri, sans-serif;
}
.card_field_75{
    width: 75%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
    height:40px;
    background:white;
    font-size:17px;
    color:#3a3a3a;
    font-family:helvetica, tahoma, calibri, sans-serif;
}
.row {
    display: -ms-flexbox; /* IE10 */
    display: flex;
    -ms-flex-wrap: wrap; /* IE10 */
    flex-wrap: wrap;
    margin: 0 -16px;
}
.col-25 {
    -ms-flex: 25%; /* IE10 */
    flex: 25%;
}
.col-50 {
    -ms-flex: 50%; /* IE10 */
    flex: 50%;
}
input[type=text], select, textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
    height:40px;
    background:white;
    font-size:17px;
    color:#3a3a3a;
    font-family:helvetica, tahoma, calibri, sans-serif;
}
input[type=submit] {
    background-color: #4CAF50;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.message_container {
    border-radius: 5px;
    background:#FFFFFF;
    font-size:13px;
    font-family:monospace;
    padding: 20px;
}
#loading {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    display: block;
    opacity: 0.7;
    background-color: #fff;
    z-index: 99;
    text-align: center;
}
#loading-image {
    position: absolute;
    z-index: 15;
    top: 50%;
    left: 50%;
    margin: -100px 0 0 -150px;
}
.spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -50px; /* half width of the spinner gif */
    margin-top: -50px; /* half height of the spinner gif */
    text-align:center;
    z-index:1234;
    overflow: auto;
    width: 100px; /* width of the spinner gif */
    height: 102px; /* height of the spinner gif +2px to fix IE8 issue */
}
.button_container {
    display: flex;
    justify-content: center;
}
button:hover {
    background-color: powderblue;
}
button {
    width:229px;
    height:49px;
    background:lightblue;
    border:1px dotted black;
    font-size:17px;
    color:#3a3a3a;
    padding: 12px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
}
.btn_small{
    width:130px;
    height:39px;
    background:lightblue;
    border:1px dotted black;
    font-size:14px;
    color:#3a3a3a;
}
.btn_small:hover {
    background-color: powderblue;
}
.paypal-button-message paypal-button-message-top {
  display:none !important; /* could override the message */
}
</style>



// WEBPACK FOOTER //
// Purchase.vue?0aa22e60